import { isArray } from "lodash";
import { isEqual } from "date-fns";
import { IAbsenceRequestDay } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";

/**
 * Function searching in collection of given absence request days for particular date.
 * Used mainly on datepickers.
 * @param {Date} day - day to check, current day or date from calendar.
 * @param {array} absenceRequestDays - collection of absence request days from API.
 * @returns {IAbsenceRequestDay} - if searched date is excluded, returns it's data.
 */
export default (day: Date, absenceRequestDays: IAbsenceRequestDay[]) => {
  if (!isArray(absenceRequestDays)) return null;

  return absenceRequestDays.find((currentDay) =>
    isEqual(day, new Date(currentDay.date).setHours(0, 0, 0))
  );
};
